import React from "react"

export default function Subtract({ className }: any) {
  return (
    <svg className={className} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.3335 7.33398H12.6668V8.66732H3.3335V7.33398Z" fill="currentColor" />
    </svg>
  )
}
